import ar_white from "../../../assets/images/ar_white.svg";
import home_white from "../../../assets/images/home_white.svg";
import busi_mo from "../../../assets/images/busi_mo.webp";
import busi_pc from "../../../assets/images/busi_pc.webp";

export default function BusinessBanner() {
  return (
    <div className="w-full pt-10 ">
      <div className="block md:hidden lg:hidden w-full relative  h-[12rem]">
        <img src={busi_mo} alt="mobi" className="w-full h-[12rem]" />
        <div className="w-full absolute top-0  h-[12rem] ">
          <div className="absolute bottom-[20%] right-[15%] flex flex-col gap-2 items-center justify-center">
            <div className="w-full h-[2.625rem] rounded-[40px] flex items-center justify-around">
              <div className="flex items-center gap-2">
                <img src={home_white} alt="home1" />
                <img src={ar_white} alt="ar" />
              </div>
              <div>
                <p className="text-[1rem] font-normal text-white whitespace-nowrap">
                  Về chúng tôi
                </p>
              </div>
              <img src={ar_white} alt="ar" />
              <div>
                <p className="text-[1rem] font-normal text-white pl-4">
                  Đối tác
                </p>
              </div>
            </div>
            <p className="text-[1.5rem] font-semibold text-white whitespace-nowrap">
              Đối tác của chúng tôi
            </p>
          </div>
        </div>
      </div>
      <div className="hidden md:block lg:block w-full relative h-[20rem]">
        <img src={busi_pc} alt="pc" className="w-full h-[20rem]" />
        <div className="w-full absolute top-0  h-[20rem] ">
          <div className="absolute bottom-[35%] right-[40%] md:right-[35%] lg:right-[40%] lg:bottom-[20%] flex flex-col gap-2 items-center justify-center">
            <div className="w-full h-[2.625rem] rounded-[40px] flex items-center justify-around">
              <div className="flex items-center gap-2">
                <img src={home_white} alt="home1" />
                <img src={ar_white} alt="ar" />
              </div>
              <div>
                <p className="text-[1rem] font-normal text-white whitespace-nowrap">
                  Về chúng tôi
                </p>
              </div>
              <img src={ar_white} alt="ar" />
              <div>
                <p className="text-[1rem] font-normal text-white pl-4">
                  Đối tác
                </p>
              </div>
            </div>
            <p className="text-[2.25rem] font-semibold text-white">
              Đối tác của chúng tôi
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
